import React from 'react';
import { Container, Row, Col, Image } from 'react-bootstrap';
import './MunicipalidadFooter.css';

const MunicipalidadFooter = () => {
  return (
    <>
      <div className="footer-social">
        <Container>
          <Row>
            <Col>
              Visitanos en
              <a href="https://www.instagram.com/turismovla" target="_blank" rel="noreferrer">
                <Image src="/assets/images/ig-social.png" />
              </a>
              <a href="https://x.com/Turismovla?mx=2" target="_blank" rel="noreferrer">
                <Image src="/assets/images/twitter-social.png" />
              </a>
              <a
                href="https://www.youtube.com/channel/UCme4GRkBsOqZKVoZp1p4kIA"
                target="_blank"
                rel="noreferrer"
              >
                <Image src="/assets/images/youtube-social.png" />
              </a>
              <a
                href="https://www.tripadvisor.com.ar/Tourism-g312844-Villa_La_Angostura_Province_of_Neuquen_Patagonia-Vacations.html"
                target="_blank"
                rel="noreferrer"
              >
                <Image src="/assets/images/tripadvisor-social.png" />
              </a>
            </Col>
          </Row>
        </Container>
      </div>
      <Container>
        <Row>
          <Col lg="2" className="footer-logo">
            <Image src="/assets/images/logo-footer.png" />
          </Col>
          <Col className="footer-info-content">
            <Row>
              <Col lg="6" xs="12" sm="12">
                <div className="footer-info">Municipalidad de Villa la Angostura</div>
                <div className="footer-sub-info">Obispo de Nevares 32</div>
                <div className="footer-sub-info">Tel:(0294)4494155/158</div>
              </Col>
              <Col lg="6" xs="12" sm="12">
                <div className="footer-info">Oficina de atención al Turismo</div>
                <div className="footer-sub-info">Av. Arrayanes 9</div>
                <div className="footer-sub-info">Tel (0294)4494124</div>
              </Col>
            </Row>
          </Col>
          <Col lg="2" className="footer-escudo">
            <Image className="footer-escudo-img" src="/assets/images/escudo_vla_web.png" />
          </Col>
        </Row>
      </Container>
      <div className="footer">
        <Container>
          <Row>
            <Col>2025 © Todos los derechos reservados | Municipalidad de Villa la Angostura</Col>
          </Row>
        </Container>
      </div>
    </>
  );
};

export default React.memo(MunicipalidadFooter);
